import { reactive } from 'vue'

/**
 * État de connexion WebSocket partagé, lisible depuis n'importe quel composant
 * (notamment la bannière « Connexion au serveur perdue »).
 *
 * - `active`        : un socket est en cours d'utilisation sur la page courante
 *                     (sinon on n'affiche aucune bannière).
 * - `connected`     : le socket est actuellement ouvert.
 * - `everConnected` : le socket s'est déjà ouvert au moins une fois. Évite que la
 *                     bannière clignote pendant la connexion initiale ; on ne la
 *                     montre que sur une vraie coupure après une connexion établie.
 */
export const wsConnectionStatus = reactive({
  active: false,
  connected: false,
  everConnected: false,
})

interface Reconnectable {
  reconnect (): void
}

// Socket courant, pour permettre une reconnexion manuelle depuis la bannière.
let currentSocket: Reconnectable | null = null

export function registerSocket (socket: Reconnectable): void {
  currentSocket = socket
  wsConnectionStatus.active = true
}

export function unregisterSocket (socket: Reconnectable): void {
  // On ne nettoie que si c'est bien le socket courant : pendant une transition
  // de route, le nouveau composant peut s'monter avant que l'ancien ne se démonte.
  if (currentSocket === socket) {
    currentSocket = null
    wsConnectionStatus.active = false
    wsConnectionStatus.connected = false
    wsConnectionStatus.everConnected = false
  }
}

export function setConnected (value: boolean): void {
  wsConnectionStatus.connected = value
  if (value) wsConnectionStatus.everConnected = true
}

export function reconnectSocket (): void {
  currentSocket?.reconnect()
}
